// Opening hours (Europe/Paris). day: 0=Sunday … 6=Saturday
export const OPENING_HOURS = [
  { day: 1, open: 8, close: 18 },
  { day: 2, open: 8, close: 18 },
  { day: 3, open: 8, close: 18 },
  { day: 4, open: 8, close: 18 },
  { day: 5, open: 8, close: 18 },
];

export const WEEK = [
  { day: 1, label: "Lundi" }, { day: 2, label: "Mardi" }, { day: 3, label: "Mercredi" },
  { day: 4, label: "Jeudi" }, { day: 5, label: "Vendredi" }, { day: 6, label: "Samedi" }, { day: 0, label: "Dimanche" },
];

export const HOURS_SUMMARY = "Lun–Ven, 8h–18h";

const slotOf = (day) => OPENING_HOURS.find((h) => h.day === day);

function parisNow(date = new Date()) {
  const parts = new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/Paris", weekday: "short", hour: "numeric", minute: "numeric", hourCycle: "h23" }).formatToParts(date);
  const get = (t) => parts.find((p) => p.type === t)?.value;
  const day = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].indexOf(get("weekday"));
  return { day, hour: Number(get("hour")) + Number(get("minute")) / 60 };
}

export function openStatus(date) {
  const { day, hour } = parisNow(date);
  const today = slotOf(day);
  if (today && hour >= today.open && hour < today.close) return { open: true, label: `Ouvert · ferme à ${today.close}h` };
  if (today && hour < today.open) return { open: false, label: `Fermé · ouvre à ${today.open}h` };
  for (let i = 1; i <= 7; i += 1) {
    const d = (day + i) % 7;
    const s = slotOf(d);
    if (s) return { open: false, label: `Fermé · ouvre ${i === 1 ? "demain" : WEEK.find((w) => w.day === d).label.toLowerCase()} ${s.open}h` };
  }
  return { open: false, label: "Fermé" };
}

export const hoursLabel = (day) => { const s = slotOf(day); return s ? `${s.open}h – ${s.close}h` : "Fermé"; };
export const todayDay = () => parisNow().day;
